import { render, staticRenderFns } from "./destination-warehouse-modal.vue?vue&type=template&id=4736df6b&scoped=true"
import script from "./destination-warehouse-modal.vue?vue&type=script&lang=js"
export * from "./destination-warehouse-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4736df6b",
  null
  
)

export default component.exports